export default __webpack_public_path__ + "media/Dropdown.8311984f.svg";